import React, { Component, lazy } from 'react'
import { NavigationContainer, Stack } from 'spc-general-component/lib/MobileNavigation'
import styled from '@emotion/styled'
import { connectRedux } from '../../utils'
import { getAccessTokenAction, getCustomerProfileFromStorageAction, pushHistoryStateAction } from '../../actions/action'
import { getProductDetailAction, updateProductDetailAction, getProductListAction } from '../../actions/productAction'
import CacheBuster from '@phurinat/react-cache-buster';
import { version } from '../../../package.json';
import moment from 'moment'
import size from 'lodash/size'
import AlertMessage from 'spc-general-component/lib/AlertMessage'
import split from 'lodash/split'
import includes from 'lodash/includes'
import isEmpty from 'lodash/isEmpty'
import Loading from 'spc-general-component/lib/Loading'
import  MobileModalFullscreen  from 'spc-general-component/lib/MobileModalFullscreen'
import queryString from 'query-string'
import { cookieStorage, history, localStorage } from '../../utils'
import { onCheckPaymentCRQRAction } from '../../actions/paymentAction'
import { setFormProcessAction } from '../../actions/formAction'

import {
  onLogoutAction,
} from '../../actions/customerAction'
const PDPA_URL = process.env.REACT_APP_PDPA_URL || ''
const Welcome = lazy(() => import('../Welcome'))
const ProductScanner = lazy(() => import('../ProductScanner'))
const ProductDetail = lazy(() => import('../ProductDetail'))
const ShoppingCart = lazy(() => import('../ShoppingCart'))
const AddNewAddress = lazy(() => import('../AddNewAddress'))
const CheckoutPage = lazy(() => import('../CheckoutPage'))
const QRPromptPay = lazy(() => import('../QRPromptPay'))
const OrderPayment = lazy(() => import('../OrderPayment'))
const OrderHistory = lazy(() => import('../OrderHistory'))
const CustomerProfile = lazy(() => import('../CustomerProfile'))
const SearchPage = lazy(() => import('../SearchPage'))
const CookiesPolicy = lazy(() => import('../../components/CookiesPolicy'))
const CookiesPolicyDetail = lazy(() => import('../../components/CookiesPolicy/CookiesPolicyDetail'))
const PointPage = lazy(() => import('../PointPage'))
const Flashsale = lazy(() => import('../Flashsale'))
const COOKIESCNAME = process.env.REACT_APP_COOKIESCNAME || ''


const mapState = (state) => {
  return {
    activeComponent: state.home.activeComponent
  }
}

const actions = {
  getAccessTokenAction,
  getCustomerProfileFromStorageAction,
  getProductDetailAction,
  updateProductDetailAction,
  pushHistoryStateAction,
  onCheckPaymentCRQRAction,
  getProductListAction,
  setFormProcessAction,
  onLogoutAction,
}

const CIDStorage = process.env.REACT_APP_CID || ''
const SAHAGROUPFAIR = process.env.REACT_APP_SAHAGROUPFAIR || ''
class Home extends Component {

  constructor (props) {
    super(props)
    this.state = {
      initialScreen: 'Welcome',
      allowCookiePolicy: cookieStorage.get('allowCookiePolicy'),
      isOpenCookiePolicy: false,
      paymentResult: {}
    }
  }

  onChangeScreen = async () => {
    const pathname = history.location.pathname
    const cid = localStorage.get(CIDStorage)
    const values = queryString.parse(this.props.location.search);
    const sgfValue = values?.eventcode;
    sgfValue && localStorage.set({
      'key': SAHAGROUPFAIR,
      value: sgfValue
    })

    if(includes(pathname, 'product')) {
      const findCode = split(pathname, '/')
      if (size(findCode) >= 3) {
        const product_code = findCode[2]
        const {
          actions: { getProductDetailAction }
        } = this.props
        Loading.open({ label: 'รอสักครู่..' })
        await getProductDetailAction({ productCode: product_code, onFunctionCallBack: this.onReceiveProductDetail })
      }
    } else if(includes(pathname, 'payment-result') && !isEmpty(JSON.parse(cid))) {
      Loading.open({ label: 'รอสักครู่..' })
      const {
        actions: { onCheckPaymentCRQRAction }
      } = this.props
      
      const paymentResult = await onCheckPaymentCRQRAction()
      this.setState({
        paymentResult: paymentResult,
        initialScreen: 'QRPromptPay'
      })
      Loading.close()
    }
  }

  onReceiveProductDetail = async ({ productDetail }) => {
    const { actions: { updateProductDetailAction } } = this.props
    if (!isEmpty(productDetail)){
      await updateProductDetailAction({ productDetail }) 
      this.setState({ initialScreen: 'ProductDetail' })
    }else{
      AlertMessage.open({
        type: 'ERROR', 
        message: `ไม่พบสินค้า`,
        closeTime: 3
      })
      window.history.pushState({}, null, `/`)
    }
    Loading.close()
  }

  componentDidMount = async () => {
    const {
      actions: {
        onLogoutAction }
    } = this.props
   
    const {
      actions: {
        getCustomerProfileFromStorageAction }
    } = this.props
      await getCustomerProfileFromStorageAction()
      await this.onLoadData()
      await this.onChangeScreen() 
      if (!cookieStorage.get(COOKIESCNAME)) {
       await onLogoutAction(true)   
    }
  }

  onLoadData = async () => {
    const { getProductListAction,setFormProcessAction } = this.props.actions
    Loading.open({ label: 'รอสักครู่..' })
    await setFormProcessAction(true)
    await getProductListAction()
    await setFormProcessAction(false)
  }
  
  onAcceptCookiePolicy =() => {
    document.cookie = `allowCookiePolicy=true; expires=${moment().add(30, 'days').toDate()}`
    cookieStorage.get('allowCookiePolicy') && this.setState({ allowCookiePolicy: true ,isOpenCookiePolicy:false})
  }

  openCookiePolicy =()=>{
    window.open(
      PDPA_URL,
      '_blank' 
    );
  }

  render = () => {
    const {allowCookiePolicy, isOpenCookiePolicy, initialScreen, paymentResult} = this.state
    return (
      <CacheBuster
        currentVersion={version}
        isEnabled={true} //If false, the library is disabled.
        isVerboseMode={false} //If true, the library writes verbose logs to console.
        loadingComponent={<></>} //If not pass, nothing appears at the time of new version check
      >
        <HomePage>
          <HomeBody id='app-body'>
            <NavigationContainer>
              <Stack.Navigator initialScreen={initialScreen}>
                <Stack.Screen options={{ headerDisabled:true }} name="Welcome" component={Welcome} />
                <Stack.Screen options={{ headerDisabled:true }} name="ProductScanner" component={ProductScanner} />
                <Stack.Screen options={{ headerDisabled:true }} name="ProductDetail" component={ProductDetail} />
                <Stack.Screen options={{ headerDisabled:true }} name="ShoppingCart" component={ShoppingCart} />
                <Stack.Screen options={{ headerDisabled:true }} name="AddNewAddress" component={AddNewAddress} />
                <Stack.Screen options={{ headerDisabled:true }} name="CheckoutPage" component={CheckoutPage} />
                <Stack.Screen options={{ headerDisabled:true }} name="QRPromptPay" component={() => <QRPromptPay paymentResult={paymentResult} />} />
                <Stack.Screen options={{ headerDisabled:true }} name="OrderPayment" component={OrderPayment} />
                <Stack.Screen options={{ headerDisabled:true }} name="OrderHistory" component={OrderHistory} />
                <Stack.Screen options={{ headerDisabled:true }} name="CustomerProfile" component={CustomerProfile} />
                <Stack.Screen options={{ headerDisabled:true }} name="SearchPage" component={SearchPage} />
                <Stack.Screen options={{ headerDisabled:true }} name="PointPage" component={PointPage} />
                <Stack.Screen options={{ headerDisabled:true }} name="Flashsale" component={Flashsale} />
              </Stack.Navigator>
              
            </NavigationContainer>
          </HomeBody>
          {!allowCookiePolicy && 
            <CookiesPolicy
              onAcceptCookiePolicy={ () => this.onAcceptCookiePolicy()}
              openCookiePolicy={ () => this.openCookiePolicy()}
            />
          }
          {isOpenCookiePolicy && 
            <MobileModalFullscreen title='นโยบายการใช้งานคุกกี้' show={isOpenCookiePolicy} onClose={() => { this.setState({ isOpenCookiePolicy: false }) }} >
            <CookiesPolicyDetail
              onAcceptCookiePolicy={ () => this.onAcceptCookiePolicy()}
              />
            </MobileModalFullscreen>
          }
        </HomePage>
       </CacheBuster>
    )
  }
}

export default connectRedux(mapState, actions)(Home)

const HomePage = styled.div`
  display: grid;
  height: 100vh;

  grid-template-rows: auto;
`
const HomeBody = styled.div`
  display: block;
  position: relative;
  height: calc(${window.innerHeight}px);
`
